import { datadogRum } from '@datadog/browser-rum';
import { vuePlugin, addVueError } from '@datadog/browser-rum-vue';
import type { App } from 'vue';

export default {
  install: (app: App) => {
    if (window.location.hostname !== 'assessfirst.info') {
      return;
    }

    datadogRum.init({
      applicationId: 'b5b7e40c-a235-43a6-885a-d5a381cfdc2f',
      clientToken: 'pub85c709539c0f5d033e2afed428c85067',
      site: 'datadoghq.eu',
      service: 'personal-account',
      env: 'development',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackResources: true,
      trackUserInteractions: true,
      trackLongTasks: true,
      plugins: [vuePlugin()],
    });

    app.config.errorHandler = addVueError;
  },
};
